<mat-card class="p-0">
  <app-single-crawler-list-toolbar
    [count]="list.paginator.totalDocs"
    labelKey="INTEGRATIONS.BACKLINK_CRAWLER.DISCOVERED_URLS_TITLE"
    [noticeMessage]="crawler().progress?.limitReached ? ('INTEGRATIONS.BACKLINK_CRAWLER.DISCOVERY_LIMIT_REACHED_NOTICE' | translate) : undefined"
    countLabelKeySingular="INTEGRATIONS.BACKLINK_CRAWLER.URL"
    countLabelKeyPlural="INTEGRATIONS.BACKLINK_CRAWLER.URLS"
    [query]="list.filters.query"
    (queryChange)="onQueryChange($event)">

    <div filters class="fx-row align-items-center">
      @if (hasPageSelection() && canEditCaptureSelection()) {
        <button class="button mr-10" (click)="setSelectionExcluded(true)">
          {{ 'INTEGRATIONS.BACKLINK_CRAWLER.EXCLUDE_SELECTION' | translate }} ({{ selection.selected.length }})
        </button>
        <button class="button mr-10" (click)="setSelectionExcluded(false)">
          {{ 'INTEGRATIONS.BACKLINK_CRAWLER.INCLUDE_SELECTION' | translate }} ({{ selection.selected.length }})
        </button>
      }
      @if (canRediscover()) {
        <button class="button mr-10" (click)="rediscover()">
          <span class="fx-row align-items-center gap-5">
            <mat-icon fontSet="material-icons-outlined">restart_alt</mat-icon>
            {{ 'INTEGRATIONS.BACKLINK_CRAWLER.REDISCOVER' | translate }}
          </span>
        </button>
      }
      <app-select [emitOnInit]="false" (change)="onDepthChange($event)" class="mr-10"
                  [label]="'INTEGRATIONS.BACKLINK_CRAWLER.DEPTH' | translate"
                  [options]="depthSelectOptions()"></app-select>
    </div>

    <span primaryAction class="fx-row align-items-center gap-10">
      <span [matTooltip]="canRunDiscovery() ? '' : ('ERRORS.' + (eligibility?.discoveryBlockReason ?? 'GENERIC')) | translate"
            [matTooltipDisabled]="canRunDiscovery()"
            [matTooltipClass]="{'uzai-tooltip':true}">
        <button class="main-button" [class.disabled]="!canRunDiscovery()" [disabled]="!canRunDiscovery()" (click)="launchDiscovery()">
          <span class="fx-row align-items-center gap-5">
            <mat-icon fontSet="material-icons-outlined" [class.spin]="isDiscovering()"> {{
                isDiscovering()
                  ? 'refresh'
                  : 'hub'
              }}</mat-icon>
            {{ 'ACTIONS.DISCOVER_LINKS' | translate }}
          </span>
        </button>
      </span>
      @if (eligibility?.isDiscoveryRunning || launchPending.isPending) {
        <button class="danger-button" (click)="cancelDiscovery()"
                matTooltip="{{ 'INTEGRATIONS.BACKLINK_CRAWLER.CANCEL_TOOLTIP' | translate }}"
                matTooltipClass="uzai-tooltip">
          <span class="fx-row align-items-center gap-5">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
            {{ 'ACTIONS.CANCEL' | translate }}
          </span>
        </button>
      }
    </span>
  </app-single-crawler-list-toolbar>

  <mat-divider></mat-divider>

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="mt-20">
    <mat-tab>
      <ng-template mat-tab-label class="text">
        {{ 'INTEGRATIONS.WEBSITE.LIST.TABS.DISCOVERY_RESULTS' | translate }}
      </ng-template>
      <ng-template matTabContent>

        @if (!list.loading && list.paginator.totalDocs === 0) {
          @if (eligibility?.canRunDiscovery) {
            <app-empty-placeholder
              [offset]="200"
              [title]="'INTEGRATIONS.BACKLINK_CRAWLER.NO_DISCOVERY_TITLE'"
              [message]="'INTEGRATIONS.BACKLINK_CRAWLER.NO_DISCOVERY_MESSAGE'">
            </app-empty-placeholder>
          } @else {
            <div class="p-16">
              <span class="text light">{{ 'DOCUMENTS_LIST.NO_DOCUMENTS' | translate }}</span>
            </div>
          }
        } @else {
          <table mat-table [dataSource]="list.paginator.docs" style="z-index: 0;" matSort
                 (matSortChange)="onSortChange($event)">

            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="toggleAllRows()" color="primary"
                              [checked]="hasPageSelection() && isAllSelected()"
                              [indeterminate]="hasPageSelection() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let discoveredUrl">
                <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="toggle(discoveredUrl)"
                              [checked]="isSelected(discoveredUrl)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="url">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="small light bold">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.URL' | translate }}</span>
              </th>
              <td mat-cell *matCellDef="let discoveredUrl">
                <a target="_blank" [href]="discoveredUrl.url" class="text bold" [class.light]="discoveredUrl.excluded">{{ discoveredUrl.url }}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="small light bold">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.STATUS' | translate }}</span>
              </th>
              <td mat-cell *matCellDef="let discoveredUrl">
                <div class="fx-row align-items-center justify-content-start gap-5">
                  @if (discoveredUrl.excluded) {
                    <span class="chip light">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.EXCLUDED' | translate }}</span>
                  }
                  <!-- read without error but holding no link: an empty page, or content that did not load -->
                  @if (discoveredUrl.linksFound === 0) {
                    <span class="chip light" [matTooltip]="'INTEGRATIONS.BACKLINK_CRAWLER.NO_LINKS_HELP' | translate"
                          [matTooltipClass]="{'uzai-tooltip':true}">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.NO_LINKS' | translate }}</span>
                  }
                  @if (discoveredUrl.status === DiscoveredUrlStatus.ERROR) {
                    <span class="chip light red" [matTooltip]="errorReason(discoveredUrl) | translate"
                          [matTooltipClass]="{'uzai-tooltip':true}">{{ errorReason(discoveredUrl) | translate }}</span>
                  } @else if (discoveredUrl.status) {
                    <span [class.green]="discoveredUrl.status === DiscoveredUrlStatus.DONE"
                          [class.red]="discoveredUrl.status === DiscoveredUrlStatus.ERROR"
                          class="chip light">{{
                        'INTEGRATIONS.BACKLINK_CRAWLER.STATUSES.' + discoveredUrl.status | translate
                      }}</span>
                  } @else {
                    <span class="chip light">{{
                        'INTEGRATIONS.BACKLINK_CRAWLER.STATUSES.' + DiscoveredUrlStatus.UNKNOWN | translate
                      }}</span>
                  }
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="depth">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="small light bold">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.DEPTH' | translate }}</span>
              </th>
              <td mat-cell *matCellDef="let discoveredUrl">
                <div class="fx-row align-items-center justify-content-start">
                  <span class="text">{{ distance(discoveredUrl.depth) }}</span>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="small light bold">{{ 'INTEGRATIONS.BACKLINK_CRAWLER.CREATED_AT' | translate }}</span>
              </th>
              <td mat-cell *matCellDef="let discoveredUrl">
                <div class="fx-row align-items-center justify-content-start">
                  <time [dateTime]="discoveredUrl.createdAt" class="text light">{{ createdAt(discoveredUrl) }}</time>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let discoveredUrl; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator [length]="list.paginator.totalDocs || 0" [pageSize]="list.paginator.limit || 0"
                         [pageIndex]="list.paginator.page ? (list.paginator.page - 1) : 0"
                         [pageSizeOptions]="pageSizeOptions"
                         (page)="handlePage($event)">
          </mat-paginator>
        }
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label class="text">
        {{ 'INTEGRATIONS.WEBSITE.LIST.TABS.DISCOVERY_GRAPHS' | translate }}
      </ng-template>
      <ng-template matTabContent>
        <div class="fx-row w-100">
          <div class="p-16 border-left fx-flex-33 border-box">
            <span class="text bold mb-16">{{'INTEGRATIONS.BACKLINK_CRAWLER.GRAPH.RESULTS_REPARTITION_BY_DEPTH' | translate}}</span>
            @if (graphData) {
              <app-graph-crawler-discovery-depth-repartition [loading]="loadingGraphData" [noData]="graphData.length === 0"
                                                             [data]="graphData"></app-graph-crawler-discovery-depth-repartition>
            }
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

</mat-card>
